import React from "react";
import { Container, Row, Col, Spinner } from "reactstrap";
import PropTypes from "prop-types";

import { Navbar as MainNavbar } from "../Navbar";
import { FreeAssessmentHeader } from "../Header";
import { Footer as MainFooter } from "../Footers";
import { LandingPageSection } from "../Sections";
import { FormCard } from "../Cards";

const PageLayout = ({
  children,
  titleText,
  loading,
  colProps,
  useFormCard,
}) => (
  <>
    <MainNavbar whiteLogo />
    <FreeAssessmentHeader />
    <LandingPageSection titleText={titleText}>
      {loading ? (
        <Spinner color="info" />
      ) : useFormCard ? (
        <Container>
          <Row>
            <Col className="mx-auto" {...colProps}>
              <FormCard>{children}</FormCard>
            </Col>
          </Row>
        </Container>
      ) : (
        children
      )}
    </LandingPageSection>
    <MainFooter />
  </>
);

PageLayout.propTypes = {
  children: PropTypes.node.isRequired,
  titleText: PropTypes.string,
  loading: PropTypes.bool,
  colProps: PropTypes.object,
  useFormCard: PropTypes.bool,
};

PageLayout.defaultProps = {
  loading: false,
  colProps: { lg: "6", md: "8", sm: "10", xs: "12" },
  useFormCard: true,
};

export default PageLayout;
